<template>
  <div v-if="microphones.length && hasPermission" class="microphone-selector">
    <label>
      <select v-model="model"
              class="microphone-selector__select-field"
      >
        <option selected disabled hidden value="">{{ $t('selectMic') }}</option>
        <option v-for="(micro,index) in microphones" :key="index" :value="micro.deviceId">
          {{ micro.label || `micro ${index + 1}` }}
        </option>
      </select>
    </label>
    <slot />
  </div>
</template>

<script>
import {
  computed, onMounted, ref,
} from '@vue/composition-api';
import useMicrophone from '@/compositions/useMicrophone';
import useStreams from '@/compositions/useStreams';

export default {
  name: 'MicrophoneSelector',
  setup(_, { emit }) {
    const {
      loadMicrophones, microphones,
    } = useMicrophone();
    const { microphoneId } = useStreams();
    const selected = ref(null);
    const model = computed({
      get: () => selected.value || microphoneId.value || '',
      set: (val) => {
        selected.value = val;
        emit('selected', selected.value);
      },
    });
    const hasPermission = computed(
      () => microphones.value.length > 0 && microphones.value[0].deviceId,
    );

    onMounted(async () => {
      await loadMicrophones();
    });

    return {
      microphones,
      selected,
      model,

      hasPermission,
    };
  },
};
</script>

<style lang="scss" scoped>
.microphone-selector {
  width: 100%;
  margin: 0 auto;
  &__select-field {
    width: 100%;
    max-width: 100%;
    background: #FFFFFF url("../assets/img/icons/select.svg") no-repeat 96% 0.875rem;
    border: 1px solid #E0E0E0;
    border-radius: 0.25rem;
    padding: 0.375rem 2rem 0.375rem 0.75rem;
    font-size: 0.875rem;
    line-height: 1.43;
    color: #757575;
    margin-bottom: 0.125rem;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    position: relative;
    cursor: pointer;

    &:focus {
      border-color: #0a82d9;
      outline: none;
    }
  }
}
@media (max-width: 374px) {
  .microphone-selector {
    width: 17.5rem;
  }
}
</style>

<i18n locale="en" lang="yaml">
selectMic: Select microphone
</i18n>

<i18n locale="ru" lang="yaml">
selectMic: Выберите микрофон
</i18n>
